// extracted by mini-css-extract-plugin
export var content = "_nr-1";
export var noScroll = "_nr-3";
export var paper = "_nr-0";
export var scrollable = "_nr-2";